export const APP_PUBLIC_NAME = {'es': 'Ventas', 'en': 'Sales'};